import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=59da251a"
import script from "./SideNavigation.vue?vue&type=script&lang=ts"
export * from "./SideNavigation.vue?vue&type=script&lang=ts"
import style0 from "./SideNavigation.vue?vue&type=style&index=0&id=59da251a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports